module.exports = __webpack_public_path__ + "static/amrit-series-top-banner-679f14e86047b91cf1e7abaaea371e8c.jpg";